/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionFastingViewAliases {
  CONTEXTUAL_BAR_FASTING = 'contextual-bar-fasting',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FASTING_TYPE = 'field-fasting-type',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_REASON = 'field-reason',
  FIELD_START_DATE = 'field-start-date',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_FASTING = 'layout-fasting',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_DURATION = 'text-duration',
  TEXT_INTERVAL_DESCRIPTION = 'text-interval-description',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_REASON = 'text-reason',
}
export { NutritionFastingViewAliases };
